import { createTheme } from "@mui/material";
export const primaryTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      mobile: 425,
      sm: 672,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});
